export enum SchedulingType {
  SBM = "SCHEDULE_BY_MOVING",
  BULK = "BULK",
  SINGLE = "SINGLE",
}
